module.exports = "/assets/data/1588cd7c96205b5af8341b9502535248-NR2.data.json";